export interface Environment {
  pageXOffset: number;
  pageYOffset: number;
  innerWidth: number;
  innerHeight: number;
  addEventListener(type: 'resize' | 'scroll', listener: (event: Event) => void): void;
  removeEventListener(type: 'resize' | 'scroll', listener: (event: Event) => void): void;
};

export const createViewportProvider = (environment: Environment = window): Environment => environment;
